import ArrowRight from '@assets/icons/arrow-right.svg'
import { Icon } from './Icon'

export const ArrowRightIcon = Icon(ArrowRight)
